import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(companyEmployeeRoute);

    /** @ngInject */
    function companyEmployeeRoute($stateProvider) {
        $stateProvider.state('company_employee', {
            url: '/panel-firmy',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/_company_employee/_company_employee.html'),
            controller: 'CompanyEmployeeController',
            controllerAs: 'CompanyEmployeeCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_company_employee/_company_employee.route.ts